module.exports = __webpack_public_path__ + "media/newstyle/images/headphones-3ae1e8ad080b1f8f6054009e4f1b8c0c.svg";